import { useEffect } from "react";

import { Typography } from "@mui/material";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import useScreenSize from "../../../../hooks/useScreenSize";

const tabs = [
	"learning-material",
	"summary",
	"service-information",
	"message",
	"syllabus",
];

export function TabContainer() {
	const { width } = useScreenSize();
	const isDesktop = width > 992;
	const [searchParams, setSearchParams] = useSearchParams();
	const tab = searchParams.get("tab") ?? "";

	useEffect(() => {
		if (isDesktop && tab === "syllabus") {
			setSearchParams(
				(prev) => {
					prev.set("tab", "learning-material");
					return prev;
				},
				{ replace: true },
			);
		}
	}, [isDesktop, setSearchParams, tab]);

	useEffect(() => {
		if (!tabs.includes(tab)) {
			setSearchParams(
				(prev) => {
					prev.set("tab", "learning-material");
					return prev;
				},
				{ replace: true },
			);
		}
	}, [setSearchParams, tab]);

	const setTab = (nextTab: string) => () => {
		setSearchParams((prev) => {
			prev.set("tab", nextTab);
			return prev;
		});
	};

	return (
		<div className="lesson-tab-container item-separator-big">
			<div className="lesson-tab-scrollable-container">
				<div
					className={classNames("tab-item", {
						selected: tab === "learning-material",
					})}
					onClick={setTab("learning-material")}>
					<Typography
						className={classNames("normal-text", {
							bold: tab === "learning-material",
						})}>
						Learning Material
					</Typography>
				</div>
				<div
					className={classNames("tab-item", { selected: tab === "summary" })}
					onClick={setTab("summary")}>
					<Typography
						className={classNames("normal-text", { bold: tab === "summary" })}>
						Summary
					</Typography>
				</div>
				<div
					className={classNames("tab-item", {
						selected: tab === "service-information",
					})}
					onClick={setTab("service-information")}>
					<Typography
						className={classNames("normal-text", {
							bold: tab === "service-information",
						})}>
						Service Information
					</Typography>
				</div>
				{!isDesktop && (
					<div
						className={classNames("tab-item", { selected: tab === "syllabus" })}
						onClick={setTab("syllabus")}>
						<Typography
							className={classNames("normal-text", {
								bold: tab === "syllabus",
							})}>
							Syllabus
						</Typography>
					</div>
				)}
				<div
					className={classNames("tab-item", { selected: tab === "message" })}
					onClick={setTab("message")}>
					<Typography
						className={classNames("normal-text", { bold: tab === "message" })}>
						Message Instructor
					</Typography>
				</div>
			</div>
		</div>
	);
}
